<i class="icon" (click)="navigateToInfoPage()">info</i>
